module.exports = __webpack_public_path__ + "img/star1_2.a2a0a65f.svg";